export const GET_ALL_CATEGORIES = "GET_ALL_CATEGORIES";
export const RESET_DATA = "RESET_DATA";
export const START_LOADING_CATEGORIES = "START_LOADING_CATEGORIES";
export const STOP_LOADING_CATEGORIES = "STOP_LOADING_CATEGORIES";
export const ERROR_LOADING_CATEGORIES = "ERROR_LOADING_CATEGORIES";